<template>
  <CCard class="dataTable dataTable--hiddenHeader py-5 mt-3">
    <CRow class="pt-5 pb-4">
      <CCol sm="12" class="d-flex flex-column">
        <div>
          <h1 class="titlePage font-weight-normal text-capitalize">
            {{ $t('templates.sms.list.title') }}
          </h1>
        </div>
      </CCol>
    </CRow>
    <CRow class="my-4">
      <CCol sm="12" v-if="totalRecords > 0">
        <CCardHeader class="dataTable__header d-flex justify-content-between px-0 pb-5">
          <div class="dataTable__search">
            <CInput
              type="search"
              :placeholder="$t('templates.sms.list.input.search')"
              addInputClasses="pl-5"
              class="iconSearchPlaceholder pb-0"
              v-model="tableFilterValue"
            >
            </CInput>
          </div>
          <div class="dataTable__buttonLink">
            <router-link class="btn btn-primary px-4 py-3 font-weight-bold" tag="button" :to="{ name: 'create-template-sms' }">{{
              $t('templates.sms.list.buttons.new-template')
            }}</router-link>
          </div>
        </CCardHeader>

        <transition name="fade">
          <MenssageAlert :messages="messages" />
        </transition>

        <HeaderActions
          :show="{
            checkItems: true,
            manage: false,
            filterBy: false,
            orderByDate: {
              type: 'edited',
              show: true,
            },
            delete: true
          }"
          :multiSelect="true"
          :itemsListSelected="Boolean(itemsListSelected.length)"
          @confirm="deleteItemsSelected"
          @checkAll="checkAll"
          @deleteAll="deleteAll"
          @filterBy="chooseFilterBy"
          @sortByDate="sortByDate"
        />

        <CCardBody class="dataTable__body p-0">
          <CDataTable
            :items="registers"
            :fields="headers"
            :table-filter="{ external: true, lazy: true }"
            :table-filter-value.sync="tableFilterValue"
            items-per-page-select
            :items-per-page.sync="itemsPerPage"
            @pagination-change="paginationChange"
            :active-page="1"
            hover
            :loading="loading"
            @row-clicked="item => goToDetails(item.smsTemplateId)"
          >
            <template #loading>
              <div class="d-flex justify-content-center align-items-center dataTable__loading">
                <CSpinner class="my-3" color="primary" />
              </div>
            </template>

            <template #select="{ item }">
              <td @click.stop="" style="width:60px">
                <div class="d-flex flex-column justify-content-center">
                  <CInputCheckbox class="text-center checkboxTable" :checked="item._selected" @update:checked="() => check(item)" custom />
                </div>
              </td>
            </template>

            <template #name="{ item }">
              <td>
                <div class="d-flex align-items-center">
                  <p class="font-weight-normal m-0">{{ item.name }}</p>
                </div>
              </td>
            </template>

            <template #createdDateTime="{ item }">
              <td>
                <div class="d-flex align-items-center">
                  <p class="font-weight-normal m-0 text-right w-100">
                    {{ $t('general.table.item.created-by') }}
                    {{ item.createdBy }}
                  </p>
                </div>
              </td>
            </template>

            <template #createdBy="{ item }">
              <td>
                <div class="d-flex align-items-center">
                  <p class="font-weight-normal m-0 text-right w-100">
                    {{ $t('general.table.item.created') }}
                    {{ formatDate(item.createdDateTime) }}
                  </p>
                </div>
              </td>
            </template>
          </CDataTable>
        </CCardBody>

        <CPagination
          v-show="pages > 0 && totalRecords > 0"
          align="center"
          :pages="pages"
          :active-page.sync="activePage"
          class="dataTable__newPagination mt-3"  
        >
          <template slot="previous-button">
            <span class="newPagination__button p-2 btnPagination">
            {{$t('audience.audienceList.text.prev')}}
            </span>
          </template>
          <template slot="next-button">
            <span class="newPagination__button p-2 btnPagination">
              {{$t('audience.audienceList.text.next')}}
            </span>
          </template>
      </CPagination>
      </CCol>
      <CCol sm="12" v-if="totalRecords == 0">
        <EmptyList
          :loading="loadingGetList"
          :linkText="$t('templates.sms.list.button.createSms')"
          :linkTo="{ name: 'create-template-sms' }"
          :title="$t('templates.sms.list.text.noTemplateSms')"
          :subTitle="$t('templates.sms.list.text.createSms')"
        />
      </CCol>
    </CRow>
  </CCard>
</template>

<script>
import EmptyList from '@/components/EmptyList'
import HeaderActions from '@/components/table/HeaderActions'
import MenssageAlert from '@/components/MenssageAlert'
import { dateTimeFormatString } from '../../../utils/dateUtil'
import services from '@/services.js'

export default {
  name: 'TemplateListEmail',
  components: {
    EmptyList,
    HeaderActions,
    MenssageAlert,
  },

  data() {
    return {
      loadingGetList: false,
      columnFilterValue: {},
      tableFilterValue: null,
      orderByEdit: 2,
      loadedItems: [],
      loading: false,
      itemsPerPage: 10,
      pages: 0,
      headers: [],
      headersShow: ['name', 'createdDateTime', 'createdBy'],
      totalPendings: 0,
      totalRecords: 0,
      itemsListSelected: [],
      activePage: 1,
      responsive: false,
      messages: [],
      templateStatusId: null,
      OrganizationStatusId: null,
      collapseDuration: 0,
      details: [],
      pagination: [],
    }
  },

  created() {
    this.loadingGetList = true
    this.getData({
      page: this.activePage,
      count: this.itemsPerPage,
      name: this.tableFilterValue,
      templateStatusId: this.templateStatusId,
      OrganizationStatusId: this.OrganizationStatusId,
      sort: this.orderByEdit,
      SortField: 'updatedDateTime', // ordenação fixa por update
    })
  },

  mounted() {},

  watch: {
    reloadParams() {
      this.onTableChange()
    },
  },

  computed: {
    registers() {
      return this.loadedItems.map(template => {
        return {
          ...template,
          _selected: this.itemsListSelected.includes(template.smsTemplateId),
          _classes: [template._classes, template._selected || this.itemsListSelected.includes(template.smsTemplateId) ? 'table-selected' : ''],
        }
      })
    },
    reloadParams() {
      return [this.activePage, this.itemsPerPage, this.tableFilterValue, this.templateStatusId, this.OrganizationStatusId, this.orderByEdit]
    },

    detailPagination() {
      const first = (this.activePage - 1) * this.itemsPerPage
      const totalPage = this.activePage * 10 > this.totalRecords ? this.totalRecords : this.activePage * 10
      return `${first} - ${totalPage}  ${this.$t('general.components.table.pagination.separate-numbers')} ${this.totalRecords}`
    },
  },

  methods: {
    headerHandle(arr) {
      let header = []
      let list = arr[0]

      try {
        for (const item in list) {
          if (this.headersShow.includes(item)) {
            header.push({
              key: `${item}`,
              label: '',
              _classes: 'hidde',
            })
          }
        }

        header.unshift({
          key: 'select',
          label: '',
          _classes: 'hidde',
          _style: 'width:60px',
        })

        return header
      } catch (error) {
        this.messagesSend.push({
          status: 'danger',
          text: error.response.data.message || 'ERROR',
        })
      }
    },

    mountItemsTable(arr) {
      return arr.reduce((acc, cur, index) => {
        acc.push({
          ...cur,
          index: index,
          _classes: [cur._classes, cur._selected ? 'table-selected' : ''],
        })
        return acc
      }, [])
    },

    getData(data) {
      this.messages = []
      this.loading = true
      let organizationId = this.$store.state.auth.organizationId

      services
        .templatesSMS(organizationId, { params: data })
        .then(templates => {
          // this.pages = templates.data.data.pagination.totalPages / ;
          this.pages = Math.ceil(templates.data.data.pagination.totalRecords / 10)
          this.totalRecords = templates.data.data.pagination.totalRecords
          this.activePage = templates.data.data.pagination.currentPage
          this.headers = this.headerHandle(templates.data.data.templates)
          this.loadedItems = this.mountItemsTable(templates.data.data.templates)
          this.pagination = templates.data.data.pagination
        })
        .catch(() => {
          this.loadedItems = []
          this.totalRecords = 0
        })
        .finally(() => {
          this.loading = false
          this.loadingGetList = false
        })
    },

    onTableChange() {
      this.loading = true
      this.getData({
        page: this.activePage,
        count: this.itemsPerPage,
        name: this.tableFilterValue,
        templateStatusId: this.templateStatusId,
        OrganizationStatusId: this.OrganizationStatusId,
        sort: this.orderByEdit,
        SortField: 'updatedDateTime', // ordenação fixa por update
      })
    },

    formatDate(date) {
      return dateTimeFormatString(date)
    },

    paginationChange(a) {
      this.itemsPerPage = a
    },

    check(item) {
      const val = Boolean(this.loadedItems[item.index]._selected)
      this.$set(this.loadedItems[item.index], '_selected', !val)
      this.checkedItem(item.smsTemplateId)
    },

    checkedItem(id = '') {
      if (this.itemsListSelected.includes(id)) {
        this.itemsListSelected = this.itemsListSelected.filter(item => item !== id)
        return
      }

      this.itemsListSelected.push(id)
    },

    checkedAllitems(state) {
      if (!state) {
        this.itemsListSelected = []
        return
      }

      this.itemsListSelected = this.loadedItems.reduce((acc, cur) => {
        acc.push(cur.smsTemplateId)
        return acc
      }, [])
    },

    checkAll(state) {
      this.loadedItems.map(item => {
        this.$set(this.loadedItems[item.index], '_selected', state)
      })

      this.checkedAllitems(state)
    },

    deleteAll() {
      this.messages = []
      let organizationId = this.$store.state.auth.organizationId

      services
        .deleteTemplatesSMS(organizationId, { data: this.itemsListSelected })
        .then(({ data }) => {
          this.loadedItems = []
          this.totalRecords = []
          this.onTableChange()

          this.messages.push({
            status: 'success',
            text: data.message ? data.message : 'selected items have been deleted',
          })
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
    },

    deleteItemsSelected() {
      this.messages = []
      let organizationId = this.$store.state.auth.organizationId

      services
        .deleteTemplatesSMS(organizationId, { data: this.itemsListSelected })
        .then(({ data }) => {
          this.itemsListSelected = []
          this.onTableChange()

          this.messages.push({
            status: 'success',
            text: data.message ? data.message : 'selected items have been deleted',
          })
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message ? response.data.message : "selected items don't been deleted",
          })
        })
    },

    chooseFilterBy(item) {
      this.templateStatusId = null
      this.OrganizationStatusId = null

      if (item === 'all') {
        return
      }

      this[item.column] = item.value
    },

    downloadDoc(fileName, originalFileName) {
      this.messages = []
      let organizationId = this.$store.state.auth.organizationId

      services
        .getDownloadDocSender(organizationId, fileName)
        .then(response => {
          fileDownload(response.data, originalFileName, response.headers['content-type'])

          this.messages.push({
            status: 'success',
            text: response.data.message || 'Success',
          })
        })
        .catch(error => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.message,
          })
        })
    },

    goToDetails(id) {
      this.$router.push({ name: 'edit-template-sms', params: { id: id } })
    },

    sortByDate(orderByEdit) {
      this.orderByEdit = orderByEdit ? 1 : 2
    },
  },
}
</script>

<style module>
.blockClick {
  pointer-events: none;
}
</style>
